module.exports = __webpack_public_path__ + "img/img_manual2_2.fde92a1a.jpg";